import { InfoCircleIcon } from "../../../shared/Icons";
import WithTooltip from "../../../shared/components/WithTooltip";
import type { AdminCrewReportBulkRequestStatusRowProps } from "../../models/admin-crew-report.models";
import { getAdminCrewReportBulkRequestStatusLabel } from "../../utils/admin-crew-report-bulk-request.utils";

const AdminCrewReportBulkRequestStatusRow = ({ item }: AdminCrewReportBulkRequestStatusRowProps) => {
  const statusLabel = getAdminCrewReportBulkRequestStatusLabel(item.status);
  const vesselLabel = item.vessel.vesselName || item.vessel.imoNumber;

  return (
    <div
      role="row"
      data-test={`admin-crew-report-bulk-request-status-${item.vessel.imoNumber}`}
      className="grid min-w-[780px] grid-cols-[minmax(130px,0.855fr)_90px_minmax(260px,1.35fr)_180px] border-b border-[#D8E6E3] text-xs last:border-b-0 dark:border-gray-700"
    >
      <div role="cell" className="min-w-0 px-3 py-2.5 font-medium">
        <span className="block truncate" title={item.vessel.vesselName}>
          {vesselLabel}
        </span>
      </div>
      <div role="cell" className="px-3 py-2.5">
        {item.vessel.imoNumber}
      </div>
      <div role="cell" className="min-w-0 px-3 py-2.5">
        <span className="block truncate" title={item.recipientEmail || undefined}>
          {item.recipientEmail || "—"}
        </span>
      </div>
      <div role="cell" className="w-[180px] px-3 py-2.5" aria-live="polite">
        {item.status === "failed" ? (
          <WithTooltip
            id={`admin-crew-report-bulk-request-error-${item.vessel.imoNumber}`}
            content={item.errorMessage}
            contentMode="text"
            openOnClick
            closeOnEsc
            clickable
            closeOnClickOutside
            place="top-end"
            className="inline-flex"
            tooltipClasses="z-[120] max-w-[320px] select-text whitespace-normal break-words"
          >
            <button
              type="button"
              aria-label={`Show Bulk Crew Report request error for ${vesselLabel}`}
              className="inline-flex items-center gap-1 font-semibold text-[#BF0002] dark:text-red-300"
            >
              Failed
              <InfoCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          </WithTooltip>
        ) : (
          statusLabel
        )}
      </div>
    </div>
  );
};

export default AdminCrewReportBulkRequestStatusRow;
